export default __webpack_public_path__ + "static/media/tick(1).8a290f57.svg";